'use strict';

var _bindInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/bind");

var implementation = require('./implementation');

module.exports = _bindInstanceProperty(Function.prototype) || implementation;